/**************************************************
 * Nombre:       Formulario_Mensajes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, PhoneIphoneOutlined, WavingHandOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSMENSAJE} from "../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {enviarNotificacionPrueba} from "../../CodNegocio/Notificaciones/enviarNotificacionPrueba";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {where} from "firebase/firestore";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";

const Formulario_Mensajes = ({...props}) => {
    const [espacios, setEspacios] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [numero, setNumero] = useState(0);



    const comprobar = async () => {

        setCargando(true);
        let valores = props.props.getValues()
        let mensaje = valores.saludo + ' [Nombre Persona] ' + valores.mensaje;
        let celular = '57'+valores.celular;

        let obj = {
            mensaje: mensaje,
            celular: celular,
        }

        await enviarNotificacionPrueba(obj)
        setTimeout(() =>{
            setCargando(false);
        },3000)


    }

    useEffect(() => {

        obtenerCol('espacios').then((dox) => {
            let espacios = dox.data
            setEspacios(espacios)
            let ops = espacios.map((valor) => valor.nombreResaltado + ' ' + valor.nombre)
            ops.push('Todos')
            setOpciones(ops)
        })

    }, [])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WavingHandOutlined} nombre={'Saludo'}
                                  dato={'saludo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={6} nombre={'Mensaje (\\n es salto de linea)'}
                                  dato={'mensaje'} {...props}
                    />
                </Grid>

                <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={PhoneIphoneOutlined} nombre={'Celular'}
                                  dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                    <Button loading={cargando} onClick={() => comprobar()} variant={'outlined'}>Comprobar</Button>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Mensajes